import { Component, inject, signal } from '@angular/core';
import { ChildrenOutletContexts, RouterOutlet } from '@angular/router';
import { trigger, transition, style, animate, query, group } from '@angular/animations';
import { SidebarComponent } from '../sidebar/sidebar';
import { HeaderComponent } from '../header/header';

@Component({
  selector: 'nf-shell',
  imports: [RouterOutlet, SidebarComponent, HeaderComponent],
  templateUrl: './shell.html',
  styleUrl: './shell.scss',
  animations: [
    trigger('routeAnimation', [
      transition('* <=> *', [
        query(':enter', [
          style({ opacity: 0, transform: 'translateY(12px)' }),
        ], { optional: true }),
        group([
          query(':leave', [
            animate('160ms ease-in', style({ opacity: 0 })),
          ], { optional: true }),
          query(':enter', [
            animate('280ms 80ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
          ], { optional: true }),
        ]),
      ]),
    ]),
  ],
})
export class ShellComponent {
  private readonly contexts = inject(ChildrenOutletContexts);
  protected readonly sidebarCollapsed = signal(false);
  protected readonly mobileMenuOpen = signal(false);

  protected onToggleMobile(): void {
    this.mobileMenuOpen.update(v => !v);
  }

  protected getRouteAnimationData(): string {
    return this.contexts.getContext('primary')?.route?.snapshot.data['animation'] ?? '';
  }
}
